module.exports = __webpack_public_path__ + "media/images/weather-icons/fill/partly-cloudy-day-drizzle-98fb423873c7868ae5d1e0d03664fb62.svg";